// apps/web/src/lib/adjustReason.ts
// Adjustment reasons are stored structured ({key, params} JSON) so they can be
// rendered in the user's locale. Rows written before this scheme carry plain
// English strings — display those verbatim.
type T = (key: string, vars?: Record<string, string | number>) => string;

export function renderAdjustReason(reason: string | null | undefined, t: T): string | null {
  if (!reason) return null;
  try {
    const parsed = JSON.parse(reason) as { key?: unknown; params?: Record<string, string | number> };
    if (typeof parsed.key === "string") return t(parsed.key, parsed.params);
  } catch { /* legacy plain-text reason */ }
  return reason;
}
